// extracted by mini-css-extract-plugin
module.exports = {"sumRow":"FzPKQmuG456oq9r7V4Qw_","sumCell":"_1YpcQW0eKPSLYe5N0Vnj3z","perMonth":"BD7IL7bQ0uZvBtLkHj0xh"};